import {
  ApolloClient,
  ApolloProvider,
  createHttpLink,
  InMemoryCache,
} from "@apollo/client";
import { createElement } from "react";

// Requests to our same-origin /graphql endpoint are authenticated automatically, so we don't
// attach a token here:
//   - Embedded Shopify app: App Bridge patches window.fetch and injects a fresh session-token
//     Authorization header (see the app-bridge.js script in layouts/application.html.erb).
//   - Admin / non-embedded: the Devise session cookie is sent (fetch defaults to same-origin
//     credentials).
// The previous authLink read window.shopifySessionToken, which was never set anywhere — dead code
// that made it look like the token was handled here when App Bridge was doing the work.
const httpLink = createHttpLink({
  uri: "/graphql",
});

export const apolloClient = new ApolloClient({
  ssrMode: process.env.NODE_ENV === "production",
  cache: new InMemoryCache(),
  link: httpLink,
});

export const withApollo = (children: any) =>
  createElement(ApolloProvider, { client: apolloClient, children });
